import React from 'react';
import { PRODUCT_TRIO } from './vegaData';

export default function VegaProductTrio() {
  return (
    <section id="product" className="px-6 lg:px-10" style={{ paddingBottom: '3rem' }}>
      <div
        style={{ maxWidth: '1200px', margin: '0 auto' }}
        className="grid md:grid-cols-3 gap-5"
      >
        {PRODUCT_TRIO.map((p, i) => (
          <article
            key={p.id}
            className={`${p.grad} rounded-3xl relative overflow-hidden transition-transform duration-300 hover:-translate-y-1`}
            style={{ padding: '1.75rem', minHeight: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
          >
            <div className="vd-star-dust absolute inset-0 pointer-events-none" style={{ opacity: 0.2 }} />

            <div style={{ position: 'relative' }}>
              <span
                className="vd-pill"
                style={{ background: 'rgba(255,255,255,.65)', borderColor: 'rgba(255,255,255,.8)' }}
              >
                0{i + 1} · {p.label}
              </span>
              <ul style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
                {p.bullets.map(b => (
                  <li
                    key={b}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      background: 'rgba(255,255,255,.55)',
                      backdropFilter: 'blur(4px)',
                      borderRadius: '0.5rem',
                      padding: '0.5rem 0.75rem',
                      fontSize: '0.875rem',
                      color: 'rgb(51,65,85)',
                    }}
                  >
                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'rgba(71,85,105,.6)', flexShrink: 0 }} />
                    {b}
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ position: 'relative', marginTop: '1.5rem', display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
              <h3
                className="vd-font-display"
                style={{ fontSize: '1.875rem', color: 'rgb(30,41,59)', lineHeight: 1 }}
              >
                {p.label}
              </h3>
              <span style={{ fontSize: '0.75rem', color: 'rgba(51,65,85,.7)' }}>{p.tagline}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
